module.exports = __webpack_public_path__ + "static/media/walk.0e3b274e.mp3";